/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Rank_InvalidInputs */

const vi_error_shop_rank_invalid = /** @type {(inputs: Error_Shop_Rank_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số nguyên từ 1 trở lên, hoặc để trống nếu không xếp hạng bán chạy.`)
};

/**

* @param {Error_Shop_Rank_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_rank_invalid = /** @type {((inputs?: Error_Shop_Rank_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Rank_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_rank_invalid(inputs)
});